import { useCallback } from "react";

import { useIntl } from "react-intl";

import messages from "../locales/messages";

const useTranslation = () => {
  const intl = useIntl();
  const t = intl.formatMessage;
  const m = messages;

  /**
   * Formats a date string using the current locale.
   * Example: "January 15" (en) or "15 de janeiro" (pt-BR)
   */
  const formatDate = useCallback(
    (date: string | Date, options?: Intl.DateTimeFormatOptions) => {
      const defaultOptions: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "long",
      };
      return intl.formatDate(date, options ?? defaultOptions);
    },
    [intl]
  );

  return {
    t,
    m,
    formatDate,
  };
};

export default useTranslation;
